import { IDatiqCellSelect } from './datiq-cell-select.interface';

export const emptyDatiqCellSelect: IDatiqCellSelect = {
    selected: false,
    disabled: false,
    indeterminate: false,
};
